import { createRoute } from '@tanstack/react-router';
import { rootRoute } from '@trashlab/sitesapp/src/routes/__root';
import { CommercialHeroSection } from '@trashlab/sitesapp/src/organizations/redebins/template/components/commercial/commercial-hero-section';
import { WhyProsLove } from '@trashlab/sitesapp/src/organizations/redebins/template/components/commercial/why-pros-love';
import { DumpsterOptions } from '@trashlab/sitesapp/src/organizations/redebins/template/components/commercial/dumpster-options';
import { ReadyWhenYouAre } from '@trashlab/sitesapp/src/organizations/redebins/template/components/shared/ready-when-you-are';
import { ServiceAreasSection } from '@trashlab/sitesapp/src/organizations/redebins/template/components/shared/service-areas-section';

const CommercialPage = () => {
  return (
    <>
      <CommercialHeroSection />
      <WhyProsLove />
      <DumpsterOptions />
      <ReadyWhenYouAre />
      <ServiceAreasSection />
    </>
  );
};

export const Route = createRoute({
  getParentRoute: () => rootRoute,
  path: '/commercial',
  component: CommercialPage,
});

